module.exports = __webpack_public_path__ + "img/a222@2x.db85592c.png";